import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/ _createElementVNode("label", {
    for: "search",
    class: "sr-only"
}, "Search", -1);
const _hoisted_2 = { class: "mt-2 relative" };
const _hoisted_3 = {
    class: "absolute inset-y-0 left-0 pl-3 flex items-center",
    "aria-hidden": "true"
};
const _hoisted_4 = ["placeholder"];
const _hoisted_5 = {
    class: "absolute inset-y-0 right-0 pl-3 flex items-center",
    "aria-hidden": "true"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_search_icon = _resolveComponent("search-icon");
    const _component_x_icon = _resolveComponent("x-icon");
    return (_openBlock(), _createElementBlock("div", null, [
        _hoisted_1,
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_search_icon, {
                    class: "mr-3 h-4 w-4 text-gray-400 cursor-pointer",
                    "aria-hidden": "true",
                    onClick: _ctx.submitSearch
                }, null, 8, ["onClick"])
            ]),
            _withDirectives(_createElementVNode("input", {
                type: "text",
                name: "search",
                id: "search",
                class: "block w-full pl-9 sm:text-sm border border-gray-300 rounded-md",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.searchString) = $event)),
                placeholder: `${_ctx.$t('filter.search')}...`,
                onInput: _cache[1] || (_cache[1] =
                    //@ts-ignore
                    (...args) => (_ctx.changeSearchValue && _ctx.changeSearchValue(...args))),
                onKeydown: _cache[2] || (_cache[2] = _withKeys(
                //@ts-ignore
                (...args) => (_ctx.submitSearch && _ctx.submitSearch(...args)), ["enter"])),
                autocomplete: "off"
            }, null, 40, _hoisted_4), [
                [_vModelText, _ctx.searchString]
            ]),
            _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_x_icon, {
                    class: "mr-3 h-4 w-4 text-gray-400 cursor-pointer",
                    "aria-hidden": "true",
                    onClick: _ctx.clearSearch
                }, null, 8, ["onClick"])
            ])
        ])
    ]));
}
